import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'WriteAssess';
const BASE_URL = 'https://www.writeassess.co.uk';
const DEFAULT_IMAGE = `${BASE_URL}/favicon.svg`;

interface SeoHeadProps {
  title: string;
  description: string;
  canonical: string;
  noindex?: boolean;
  ogType?: 'website' | 'article';
}

export default function SeoHead({
  title,
  description,
  canonical,
  noindex = false,
  ogType = 'website',
}: SeoHeadProps) {
  const fullTitle = `${title} — ${SITE_NAME}`;
  const canonicalUrl = `${BASE_URL}${canonical}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_IMAGE} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
}
